<template>
    <div class="title">
        <span></span>{{titleText}}
<!--        <div class="btns" v-if="isShow" style="display: inline-block;">   -->
<!--            <el-button>系统通知</el-button>-->
<!--            <el-button>点赞</el-button>-->
<!--            <el-button>留言</el-button>-->
<!--        </div>-->
    </div>
</template>
<script>
    export default {
      name: 'CommentTitle',
      props:["titleText","isShow"],
      data () {
        return {

        };
      },
      methods: {

      }
    }
</script>
<style lang="less" scoped>

@title_color: #333;
@sub_color: #3370ff;
    .title span{
        display: inline-table;
        width: 10px;
        height: 20px;
        // background: #FFB463;
        background-color: @sub_color;
        border-radius: 5px;
        margin-right: 48px;
    }
    .title{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        // color: #3370ff;
        color: @title_color;
    }
    .btns{
        margin-left: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Title.vue